function getDateObject(stringDate) {
  if (stringDate) {
    let dateValues = stringDate.split("-");
    let date = new Date();
    date.setDate(parseInt(dateValues[2]));
    date.setMonth(parseInt(dateValues[1]) - 1);
    date.setFullYear(parseInt(dateValues[0]));
    return date;
  }
  return "";
}

export default function getAge(birth_date) {
  try {
    birth_date = getDateObject(birth_date);
    let today = new Date();
    let age = today.getFullYear() - birth_date.getFullYear();
    let differenceInMonths = today.getMonth() - birth_date.getMonth();
    if (
      differenceInMonths < 0 ||
      (differenceInMonths === 0 && today.getDate() < birth_date.getDate())
    ) {
      age--;
    }
    if (isNaN(age)) {
      return "NA";
    }
    return age;
  } catch (error) {
    console.log("Error en getAge: ", error);
    return "NA";
  }
}
